const TrophyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 4h12v4a6 6 0 0 1-12 0V4zM4 4h2v4a2 2 0 0 1-2-2V4zM18 4h2v2a2 2 0 0 1-2 2V4zM10 16h4v4h-4zM8 20h8" stroke="#9CA3AF" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default TrophyIcon
